export default "/_next/static/fonts/tt_norms_pro_extrablack_italic-b4f1d6bbbe92454c9a7a92fe57fd78cd.woff";